export default "__VITE_ASSET__f1018d41__"